import {PopoverElement} from 'frontend/src/app/classes/popover-element';
import L from 'leaflet';
import {LeafletFeature} from '../classes/leaflet-feature';
import {LeafletMapLayer} from '../classes/leaflet-map-layer';
import {LeafletVectorSource} from '../classes/leaflet-vector-source';
import {FeatureStyle} from '../interfaces/style.interface';

export class WastewaterTreatmentSource extends LeafletVectorSource {
    constructor(layerInfo: LeafletMapLayer) {
        super(layerInfo);
    }

    /**
     * Process the features into Leaflet Features to display on the map
     * @param features Features to display on map
     */
    processFeatures(features: any[]): void {
        const leafletFeatures = features
            .map((f) => {
                const feature = new LeafletFeature(f);

                const properties = feature.properties;
                const data = [
                    new PopoverElement().setTitle().setValue('Wastewater Treatment Plants'),
                    new PopoverElement().setLabel('Name').setValue(properties.CWP_NAME),
                    new PopoverElement()
                        .setLabel('City')
                        .setValue(properties.CWP_CITY !== null ? `${properties.CWP_CITY}, ${properties.CWP_STATE}` : 'Not Available'),
                    new PopoverElement().setLabel('Facility Type').setValue(properties.CWP_FACILITY_TYPE_DESC),
                    new PopoverElement().setLabel('Status').setValue(properties.CWP_MAJOR_MINOR_STATUS),
                    new PopoverElement().setLabel('Permit Status').setValue(properties.CWP_PERMIT_STATUS_DESC),
                ];

                feature.popoverData = data;
                feature.subFeatures = [
                    {
                        id: properties.OBJECTID_1,
                        popoverData: data,
                    },
                ];
                return feature;
            })
            .filter((f) => !!f);

        const style = (feature: LeafletFeature, latlng: L.LatLng): L.Layer => {
            return (L as any).shapeMarker(latlng, getStyle(feature));
        };

        const layerPopover = (f: LeafletFeature, l) => {
            this.initializePopoverInteractions(f, l, 'click', false, f.popoverData);
        };

        const config = {
            pointToLayer: style,
            onEachFeature: layerPopover,
            features: this.leafletFeatures,
        };

        this.source = L.geoJSON(leafletFeatures as any, config as any);
    }
}

/**
 * Determines how a features should look when displayed
 * @param feature Feature to get the style for
 * @returns Feature style
 */
function getStyle(feature: any): any {
    const status = feature.properties.CWP_MAJOR_MINOR_STATUS;
    const color = status === 'Major' ? '#33B333' : status === 'Minor' ? '#90C963' : '#878787';

    return {
        shape: 'triangle',
        radius: status === 'Major' ? 7 : 5,
        fillColor: color,
        stroke: status === 'Major',
        color: '#000',
        weight: 1,
        fillOpacity: 1,
    } as any;
}
